import { render, staticRenderFns } from "./roleList.vue?vue&type=template&id=4337b62a"
import script from "./roleList.vue?vue&type=script&lang=js"
export * from "./roleList.vue?vue&type=script&lang=js"
import style0 from "./roleList.vue?vue&type=style&index=0&id=4337b62a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports